// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!M:\\_AE\\DaganMind - free template - harry potter\\website\\src\\pages\\404.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!M:\\_AE\\DaganMind - free template - harry potter\\website\\src\\pages\\index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!M:\\_AE\\DaganMind - free template - harry potter\\website\\.cache\\json\\layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!M:\\_AE\\DaganMind - free template - harry potter\\website\\.cache\\json\\404.json"),
  "index.json": require("gatsby-module-loader?name=path---index!M:\\_AE\\DaganMind - free template - harry potter\\website\\.cache\\json\\index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!M:\\_AE\\DaganMind - free template - harry potter\\website\\.cache\\json\\404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!M:/_AE/DaganMind - free template - harry potter/website/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js